import { render, staticRenderFns } from "./ProductAddOnItems.vue?vue&type=template&id=b65b7df8"
import script from "./ProductAddOnItems.vue?vue&type=script&lang=js"
export * from "./ProductAddOnItems.vue?vue&type=script&lang=js"
import style0 from "./ProductAddOnItems.vue?vue&type=style&index=0&id=b65b7df8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports